import { combineReducers } from "redux";
import { cartReducer } from "./cartReducer";
import productReducer from "./productReducer";
import { newArrivalReducer } from "./newArrivalReducer";
import productDetailsReducer from "./productDetailsReducer";
import wishlistReducer from "./wishlistReducer";
import { buyNowReducer } from "./buyNowReducer";
import userProfileReducer from "./profileReducer";
import collectionReducer from "./collectionReducer";
import productFilterReducer from "./productFilterReducer";
import addressReducer from "./addressReducer";
import placeOrderReducer from "./placeOrderReducer";
import authReducer from "./authReducer";
import { similarProductReducer } from "./similarProductReducer";
import filterReducer from "./filterReducer";
import { contentReducer } from "./contentReducer";
import blockbusterReducer from "./blockbusterReducer";
import { latestNewsReducer } from "./latestnewsReducer";
import couponsReducer from "./couponsReducer";
import filterOptionsReducer from "./filterOptionsReducer";
import vendorRegistrationReducer from "./vendorRegistrationReducer";
import vendorKycReducer from "./vendorKycReducer";
import storageSession from "redux-persist/lib/storage/session";
import { persistReducer } from "redux-persist";
import shippingReducer from "./shipingReducers";
import { paymentReducer } from "./paymentReducer";
import popularProductsReducer from "./popularProductsReducer";
import stockReducer from "./stockReducer";
import {
  getProductReviewReducer,
  productReviewReducer,
} from "./productReviewReducer";
import { notificationReducer } from "./notificationReducer";
import { exchangeOrderReducer } from "./exchangeOrderReducer";

/* 1) Persist config for vendorRegistration → sessionStorage */
const registrationPersistConfig = {
  key: "vendorRegistration",
  storage: storageSession,
};

/* 2) Persist config for vendorKyc → sessionStorage */
const kycPersistConfig = {
  key: "vendorKyc",
  storage: storageSession,
};

export const rootReducer = combineReducers({
  auth: authReducer,
  cart: cartReducer,
  categoryProducts: productReducer,
  newArrivals: newArrivalReducer,
  productDetails: productDetailsReducer,
  wishlist: wishlistReducer,
  buyNow: buyNowReducer,
  userProfile: userProfileReducer,
  collection: collectionReducer,
  productFilter: productFilterReducer,
  address: addressReducer,
  placeOrderReducer: placeOrderReducer,
  similarProduct: similarProductReducer,
  filters: filterReducer,
  filterOptions: filterOptionsReducer,
  content: contentReducer,
  blockbuster: blockbusterReducer,
  latestNews: latestNewsReducer,
  coupons: couponsReducer,
  shippingReducer: shippingReducer,
  paymentReducer: paymentReducer,
  vendorRegistration: vendorRegistrationReducer,
  vendorRegistration: persistReducer(
    registrationPersistConfig,
    vendorRegistrationReducer
  ),
  vendorKyc: persistReducer(kycPersistConfig, vendorKycReducer),
  popularProducts: popularProductsReducer,
  stock: stockReducer,
  productReview: productReviewReducer,
  getProductReview: getProductReviewReducer,
  notifications: notificationReducer,
  exchangeOrder: exchangeOrderReducer,
});
// addressReducer: addressReducer,
